// extracted by mini-css-extract-plugin
export default {"logo-fallback":"styles_logo-fallback__vLY+w"};